import styled from "@emotion/styled";
import {
  Button,
  Col,
  Dropdown,
  Menu,
  MenuProps,
  message,
  Modal,

  Tag,

  Typography,
} from "antd";
import { FC, useState } from "react";
import { bags, comments, hearts, stock } from "assets/icons";
import { GetProductListData } from "services/interface";
import { ExclamationCircleFilled, StarFilled } from "@ant-design/icons";
import { apiErrorMessage, handleLinkedStockDependentsError } from "components/ManageProduct/LinkedStockDependentsModal";
import { useDeleteProduct, useUpdateStatusProduct } from "hooks/useProduct";
import { useNavigate } from "react-router-dom";
import { SafeProductImage } from "../SafeProductImage";
import ProductAddDialogs from "../UpdateProduct/ManageStockDialogs/ProductAddDialogs";
import { numberFormatInt } from "utils/nuberFormat";


interface ProductCardProps {
  data: GetProductListData | undefined;
  refetch: () => void;
  refetchTo?: () => void;
}

const { confirm } = Modal;

const ProductCard: FC<ProductCardProps> = ({ data, refetch, refetchTo }) => {
  const [open, setOpen] = useState<boolean>(false);

  const showDrawer = () => {
    setOpen(true);
  };

  const { mutate } = useDeleteProduct();
  const { mutate: updateStatus } = useUpdateStatusProduct();
  const navigate = useNavigate();

  const showDeleteConfirm = () => {
    if (!data?.id) return;
    confirm({
      title: "คุณต้องการลบสินค้าชิ้นนี้ใช่หรือไม่",
      icon: <ExclamationCircleFilled />,
      content: "คุณต้องการลบสินค้าชิ้นนี้ใช่หรือไม่",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        mutate(data?.id, {
          onSuccess: () => {
            message.success("ลบสินค้าสำเร็จ");
            refetch();
          },
          onError: (err: any) => {
            if (handleLinkedStockDependentsError(err)) return;
            message.error(apiErrorMessage(err, "ลบสินค้าไม่สำเร็จ"));
          },
        });
      },
      onCancel() {
        //console.log("Cancel");
      },
    });
  };

  return (
    <>
      <Col sm={24} md={12} xl={8} span={24}>
        <CardWrapper>
          <CardContentWrapper>
            <ImageWrapper>
              <SafeProductImage
                src={data?.image_url}
                alt="Product order"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </ImageWrapper>
            <TextWrapper>
              <Typography.Text className="text-order-product-name">
                {data && data.name && data?.name.length > 50
                  ? data?.name.slice(0, 50) + "..."
                  : data?.name}
              </Typography.Text>
              <Typography.Text className="text-order-product-name">
                {data && data.description && data?.description.length > 60
                  ? data?.description.slice(0, 60) + "..."
                  : data?.description}
              </Typography.Text>
              <Typography.Text className="text-order-product-price">
                ราคา :{data?.sell_price_range}
              </Typography.Text>

              <TagWrapper>
                {data?.is_recommend && (
                  <Tag color="#650C0E">สินค้าแนะนำ</Tag>
                )}
                {data?.is_cod && (
                  <Tag color="orange">COD</Tag>
                )}
                {data?.is_dead_stock && (
                  <Tag color="volcano">สินค้าค้างสต๊อก</Tag>
                )}
              </TagWrapper>
            </TextWrapper>
          </CardContentWrapper>
          <Divider />
          <CardPriceWrapper>
            <RowStockAndOrder>
              <ColumnStock>
                <IconWrapper>
                  <SpanIcon>{bags}</SpanIcon>
                </IconWrapper>
                <Typography.Text className="text-order-product-stock">
                  ยอดขาย {numberFormatInt(data?.total_sold ?? 0)}
                </Typography.Text>
              </ColumnStock>
              <ColumnStock>
                <IconWrapper>
                  <SpanIcon>
                    <StarFilled style={{ color: "#FAAD14" }} />
                  </SpanIcon>
                </IconWrapper>
                <Typography.Text className="text-order-product-stock">
                  {(data?.order_rating ?? 0).toFixed(1)}
                </Typography.Text>
              </ColumnStock>
              <ColumnStock>
                <IconWrapper>
                  <SpanIcon>{hearts}</SpanIcon>
                </IconWrapper>
                <Typography.Text className="text-order-product-stock">
                  ถูกใจ {data?.total_favourite ?? 0}
                </Typography.Text>
              </ColumnStock>
            </RowStockAndOrder>
          </CardPriceWrapper>
          <Divider />
          <DateWrapper>
            <Button
              onClick={() => {
                updateStatus(
                  {
                    id: data?.id || '',
                    is_active: !data?.is_active,
                  }, {
                  onSuccess: (data) => {
                    if (data.status === "success") {
                      message.success("แก้ไขสำเร็จ");
                      refetch();
                      if (refetchTo !== undefined) {
                        refetchTo();
                      }
                    } else {
                      message.error("แก้ไขไม่สำเร็จ");
                    }
                  },
                  onError: () => {
                    message.error("แก้ไขไม่สำเร็จ");
                  },
                });
              }}
              style={{
                width: "100%",
                // color: "#A0A0A0"
              }}
            >
              {data?.is_active ? "ปิดการขาย" : "เปิดการขาย"}
            </Button>
            <Button
              onClick={() => {
                navigate(`/manage-product/edit/${data?.id}`);
              }}
              style={{
                width: "100%",
                marginLeft: 10,
                marginRight: 10,
                // color: "#A0A0A0",
              }}
            >
              แก้ไข
            </Button>
            <Button
              onClick={() => {
                // เปิดหน้าเพิ่มสินค้าที่กรอกข้อมูลจากสินค้านี้ไว้แล้ว — บันทึกเมื่อผู้ใช้กดเอง
                navigate(`/manage-product/create-product/clone/${data?.id}`);
              }}
              style={{
                width: "100%",
                marginRight: 10,
              }}
            >
              คัดลอก
            </Button>
            <Dropdown
              overlay={<Menu>
                <Menu.Item
                  key="1"
                  onClick={() => {
                    showDeleteConfirm();
                  }}
                >
                  ลบสินค้า
                </Menu.Item>
                {/* <Menu.Item
                key="2"
                onClick={() => {
                  showDrawer();
                } }
              >
                เพิ่มสต๊อกสินค้า
              </Menu.Item> */}
              </Menu>}
            >
              <Button
                className="product-btn"
                style={{
                  width: 50,
                  // color: "#A0A0A0",
                }}
              >
                ...
              </Button>
            </Dropdown>
          </DateWrapper>
        </CardWrapper>
      </Col><ProductAddDialogs id={data?.id} open={open} setOpen={setOpen} />
    </>
  );
};

export default ProductCard;
const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px;
  background-color: #ffffff;
  border-radius: 0px;
`;

const CardContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
`;

const ImageWrapper = styled.div`
  width: 80px;
  height: 80px;
  background-color: #efefef;
  margin-right: 10px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: flex-start;
  min-height: 80px;
  width: auto;
  border-radius: 0px;
  cursor: pointer;
  position: relative;
`;

const TagWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 4px;

  .ant-tag {
    margin-inline-end: 0;
  }
`;

const CardPriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: auto;
  border-radius: 0px;
  cursor: pointer;
  padding-top: 0px;
`;

const Divider = styled.div`
  border-bottom: 0.5px solid #e8e8e8;
  margin: 10px 0px 10px 0px;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 20px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
  margin-bottom: 0px;
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const DateWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  text-align: center;
`;

const RowStockAndOrder = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: auto;
  padding: 0px 0px 5px 0px;
`;

const ColumnStock = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: auto;
`;

const StockInfoRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 6px;
  width: 100%;
  padding: 6px 0 2px 0;
  flex-wrap: wrap;
`;

const StockBadge = styled.div<{ color: string; textColor: string }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${(p) => p.color};
  color: ${(p) => p.textColor};
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 11px;
  white-space: nowrap;
`;